var PathsScenarios = require('../scenarios');
module.exports = function () {
  var options = PathsScenarios.list().map(function (scenario) {
    return "<option value=\"".concat(scenario.id, "\">").concat(scenario.label, "</option>");
  }).join("\n            ");
  var html = "\n        <label for=\"deckselect\">Scenario:</label>\n        <div class=\"overlay-input\">\n          <select class=\"saito-form-select\" name=\"deck\" id=\"deckselect\">\n            ".concat(options, "\n          </select>\n        </div>\n          ");
  return html;
};